<script lang="ts">
  import { uniq } from "lodash-es";
  import { searchFilter, updateSearchFilter } from "state/page";
  import { availableRightsMarkers, type RightsMarker } from "state/params";

  $: selected = $searchFilter?.rightsMarker ?? [];

  function onChange(this: HTMLInputElement & { value: RightsMarker }) {
    if (this.checked) {
      updateSearchFilter("rightsMarker", uniq(selected.concat(this.value)));
    } else {
      updateSearchFilter(
        "rightsMarker",
        selected.filter((v) => v !== this.value),
      );
    }
  }
</script>

<button type="button">Bruksrettigheter</button>
<bb-expand hidden={false}>
  <div class="sources">
    {#each availableRightsMarkers as rightsMarker (rightsMarker)}
      <label>
        <input
          type="checkbox"
          class="org-input"
          checked={selected.includes(rightsMarker.name)}
          on:change={onChange}
          value={rightsMarker.name}
        />
        {rightsMarker.label}
      </label>
    {/each}
  </div>
</bb-expand>

<style>
  /** Alignment is off with default values, but shouldn't need this much tweaking */
  .sources {
    display: flex;
    flex-direction: column;
    gap: var(--org-xsmall);
  }
</style>
